const language = useCurrentLanguage()

const langPrefix = computed(() => {
  return language.value === 'de' ? '' : `/${language.value}`
})

export async function userLogin(
  mail: string,
  password: string,
  destination: string = '',
) {
  const { $texts } = useNuxtApp()
  const variables = {
    username: mail,
    password,
  }

  return await useGraphqlMutation('userLogin', variables)
    .then((v) => {
      // Login successful.
      const uid = v.data.userLogin?.uid

      // Check if login was successful.
      if (v.data.userLogin?.success) {
        // If a destination query param was provided, redirect to there.
        // This is the case when trying to access protected files or during the
        // oauth flow.
        if (destination) {
          window.location.href = destination
          return
        }

        // Redirect to user profile.
        window.location.href = `${langPrefix.value}/user/${uid}`
        return
      }

      // Handle login errors. We should be receiving a message here. If not,
      // throw an error which will show a generic error message.
      if (!v.data.userLogin?.error) {
        throw new Error('Unexpected error')
      }

      const error = v.data.userLogin?.error

      // User is already logged in.
      if (error && error.includes('This route can only be accessed')) {
        // Redirect to the user profile.
        window.location.href = `${langPrefix.value}/user`
      }

      return error
    })
    .catch(() => {
      return $texts(
        'loginError',
        'Unerwarteter Fehler. Bitte versuchen Sie es noch einmal oder kontaktieren Sie uns.',
      )
    })
}
